import type { LucideIcon } from 'lucide-react'
import { Inbox } from 'lucide-react'
import type { ReactNode } from 'react'

export function Empty({
  icon: Icon = Inbox,
  title,
  description,
  action,
}: {
  icon?: LucideIcon
  title: string
  description?: string
  action?: ReactNode
}) {
  return (
    <div className="py-16 text-center animate-page-in">
      <div className="mx-auto mb-4 relative size-14">
        <div aria-hidden className="absolute inset-0 rounded-full bg-cyan-500/15 blur-lg" />
        <div className="relative size-14 rounded-full bg-zinc-900/70 border border-cyan-500/20 grid place-items-center shadow-[0_0_0_1px_rgba(34,211,238,0.05)_inset,0_0_24px_-6px_rgba(34,211,238,0.3)]">
          <Icon className="size-6 text-cyan-300/80" />
        </div>
      </div>
      <h3 className="font-display text-base font-semibold text-zinc-200 tracking-tight">{title}</h3>
      {description && (
        <p className="mt-1.5 text-sm text-zinc-500 max-w-sm mx-auto leading-relaxed">
          {description}
        </p>
      )}
      {action && <div className="mt-6">{action}</div>}
    </div>
  )
}

export function Skeleton({ className }: { className?: string }) {
  return <div className={`shimmer rounded-md ${className ?? 'h-4 w-24'}`} />
}
